
import { useState } from 'react';
import SelectType from '../component/SelectType';
import FormLogin from '../component/LoginCom/Form';
import AuthComp from '../component/AuthComp';
import OTP from './OTP';

function Login() {

    const [type, setType] = useState('selectUser');
    const [typeOTP, setTypeOTP] = useState('email');
    const handleClickOTP = (val) => {
        setTypeOTP(val);
    }
    const handleClick = (val) => {
        setType(val);
    }

    return (
        <AuthComp type={type} setType={setType} page="login" arrowBack typeOTP={typeOTP} setTypeOTP={setTypeOTP} >
            {type === 'selectUser' ?
                <SelectType type={type} setType={setType} handleClick={handleClick} page="login" />
                :
                type === 'OTP' ? <OTP type={typeOTP} handleClick={handleClickOTP}  /> :
                     <FormLogin type={type} setType={setType} handleClick={handleClick} />
            }
        </AuthComp>

    );
}

export default Login;